export class EazyNavigatorError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'EazyNavigatorError';
    Object.setPrototypeOf(this, EazyNavigatorError.prototype);
  }
}

export class ConfigError extends EazyNavigatorError {
  constructor(message: string) {
    super(message);
    this.name = 'ConfigError';
    Object.setPrototypeOf(this, ConfigError.prototype);
  }
}

export class ConnectionError extends EazyNavigatorError {
  constructor(message: string) {
    super(message);
    this.name = 'ConnectionError';
    Object.setPrototypeOf(this, ConnectionError.prototype);
  }
}

export class ValidationError extends EazyNavigatorError {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
    Object.setPrototypeOf(this, ValidationError.prototype);
  }
}
